import { useSnapshot } from 'valtio';
import AppStore from '../stores/app-store';

export const useAppStore = () => useSnapshot(AppStore);
